import { PageQuery } from '@models/common.model';
import { ProductQueryType } from '@models/product.model';

export const SETTING_KEYS = {
  jwt: 'nutri_jwt',
  location: 'nutri_location',
} as const;

export const DEFAULT_PAGE_QUERY: PageQuery = {
  page: 1,
  size: 10,
  sortField: 'createdDate',
  sort: 'desc',
};

export const SKIP_RECORD_ROUTE = 'skipRecord';

export const PUBLIC_ROUTE = 'public';

export const CK_EDITOR_CONFIG = {
  toolbar: {
    items: [
      'undo',
      'redo',
      '|',
      'heading',
      'insertTable',
      '|',
      'bold',
      'italic',
      'link',
      'blockQuote',
      '|',
      'bulletedList',
      'numberedList',
      'outdent',
      'indent',
    ],
  },
};

export const REGIONS = ['Miền Bắc', 'Miền Trung', 'Miền Nam', 'Vùng khác'];

export const PROVINCES = [
  'HN1',
  'HN2',
  'HN3',
  'HN4',
  'HN5',
  'Bắc Ninh',
  'Hà Nam',
  'Hải Dương',
  'Hải Phòng',
  'Hưng Yên',
  'Nam Định',
  'Ninh Bình',
  'Thái Bình',
  'Vĩnh Phúc',
  'Hòa Bình',
  'Sơn La',
  'Điện Biên',
  'Lai Châu',
  'Lào Cai',
  'Yên Bái',
  'Phú Thọ',
  'Hà Giang',
  'Tuyên Quang',
  'Cao Bằng',
  'Bắc Kạn',
  'Thái Nguyên',
  'Lạng Sơn',
  'Bắc Giang',
  'Quảng Ninh',
  'Thanh Hóa',
  'Nghệ An',
  'Hà Tĩnh',
  'Quảng Bình',
  'Quảng Trị',
  'Thừa Thiên Huế',
  'TP Đà Nẵng',
  'Quảng Nam',
  'Quảng Ngãi',
  'Bình Định',
  'Phú Yên',
  'Khánh Hòa',
  'Ninh Thuận',
  'Bình Thuận',
  'Kon Tum',
  'Gia Lai',
  'Đắk Lắk',
  'Đắk Nông',
  'Lâm Đồng',
  'Long An',
  'Đồng Tháp',
  'Tiền Giang',
  'An Giang',
  'Bến Tre',
  'Vĩnh Long',
  'Trà Vinh',
  'Hậu Giang',
  'Kiên Giang',
  'Sóc Trăng',
  'Bạc Liêu',
  'Cà Mau',
  'TP Cần Thơ',
  'Bình Dương',
  'Bình Phước',
  'Đồng Nai',
  'Tây Ninh',
  'Bà Rịa - Vũng Tàu',
  'SG1',
  'SG2',
  'SG3',
  'SG4',
  'SG5',
  'Khu vực khác',
];

export const QUERY_TYPE_OPTION = [
  { value: ProductQueryType.nutriShop, label: 'Nutrishop' },
  { value: ProductQueryType.retail, label: 'Nhà bán lẻ' },
  { value: ProductQueryType.shop, label: 'Dành cho đại lý' },
  { value: ProductQueryType.vip, label: 'Khách hàng thân thiết' },
];
